import { render, staticRenderFns } from "./order-status.vue?vue&type=template&id=4c41156c&scoped=true"
import script from "./order-status.vue?vue&type=script&lang=js"
export * from "./order-status.vue?vue&type=script&lang=js"
import style0 from "./order-status.vue?vue&type=style&index=0&id=4c41156c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c41156c",
  null
  
)

export default component.exports